import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectFolder } from '../../../store/person/person.selectors';
import { isFolderReadOnly } from '@libs/types/src/services/enum/folder-status.enum';

@Injectable()
export class VoucherDetailGeneralStore2 extends ComponentStoreV2Factory {

    folder = globalStore!.selectSignal(selectFolder);
    isTerminated = computed(() => isFolderReadOnly(this.folder()));

}
